import React, { FC } from 'react';
import cx from 'classnames';
import styles from './Table.module.scss';

// components
import { Link } from 'src/components/Inputs';

interface Props {
  header: string;
  columns: string[];
  rows: {
    title: string;
    url: string;
    description: string;
    hasBoldText: boolean;
  }[][];
}

const Table: FC<Props> = ({ header, columns, rows }) => {
  return (
    <div className={cx('grid-container', styles.container)}>
      <h4 className={styles.header}>{header}</h4>
      <table className={styles.table}>
        <thead className={styles.tableHeader}>
          <tr>
            {columns.map((columnItem, i) => {
              return (
                <th className={styles.tableColumn} key={`columnItem-${i}`}>
                  {columnItem}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => {
            return (
              <tr className={styles.tableRow} key={`row-${i}`}>
                {row.map((rowItem, i) => {
                  return (
                    <td className={styles.tableRowItem} key={`rowItem-${i}`}>
                      {rowItem.url ? (
                        <Link href={rowItem.url}>
                          <a
                            className={cx(styles.title, {
                              [styles.boldText]: rowItem.hasBoldText,
                            })}
                          >
                            {rowItem.title}
                          </a>
                        </Link>
                      ) : (
                        <div
                          className={cx(styles.title, {
                            [styles.boldText]: rowItem.hasBoldText,
                          })}
                        >
                          {rowItem.title}
                        </div>
                      )}
                      <p
                        className={cx(styles.description, {
                          [styles.boldText]: rowItem.hasBoldText,
                        })}
                      >
                        {rowItem.description}
                      </p>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
